<template lang="pug">
  div
    h2 Puppies
    p Here is stuff about the puppies
</template>

<script>

export default {
  name: 'TraineePuppies'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TraineePuppies.vue